import { gql } from 'apollo-boost';
import { useMutation } from '../';

const query = gql`
  mutation deleteIndicator(
    $id: Int!,
  ) {
  deleteIndicator(
    id: $id,
  ) {
      success
      id
    }
  }
`;

export function useDeleteIndicator() {
  const { data, isLoading, mutate } = useMutation();

  const run = (variables, onFinish) => {
    mutate(query, variables, () => {
      if (onFinish) {
        onFinish();
      }
    });
  };

  return { data, isLoading, run };
}
